module.exports = __webpack_public_path__ + "img/logo.cf3c9429.png";